import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Keyboard } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { Divider, useTheme } from 'react-native-paper';
import LoadingComponent from '../../common_modules/components/Loading/Loading';
import { useMarket } from '../Market/hook/useMarket';
import { Carrier, Category } from '../Market/reducer/state';
import HomeIntroWeb from './HomeIntroWeb';
import _ from 'lodash';
import { FAVORITE_CARRIERS } from '../Market/MarketWizard/StepWelcome/FavoriteCarriers.graphql';
import { useMediaQuery } from "react-responsive";
import { HomeContent } from './HomeContent';
import Footer from '../../common_modules/components/Footer/Footer';
import { isWebPlatform, IS_DESKTOP_OR_LAPTOP, IS_SMARTPHONE } from '../../common_modules/lib/PlatformDevice';
import BottomTabNavigator from '../../common_modules/components/BottomTabNavigator/BottomTabNavigator';
import { useApolloGraphQL } from '../../common_modules/providers/ApolloGraphQL/hook/useGraphqlApolloClient';

export default function Home() {
    const {
        uiSettings,
        saveSettings,
        quickSale,
        storeInfo,
        loadingMarketInfo,
        loadMarketInfo,
        categoryState,
        loadCategories,
        selectCategory,
        selectCarrier,
        selectProduct
    } = useMarket();
    const [loadedCarriers, setLoadedCarriers] = useState<string[]>([]);
    const [carriers, setCarriers] = useState<Carrier[]>([]);
    const [loading, setLoading] = useState(false);
    const [keyboardShow, setKeyboardShow] = useState(false);
    const [tab, setTab] = useState('home');
    const { client } = useApolloGraphQL();
    const isSmartPhone = useMediaQuery(IS_SMARTPHONE);
    const isDesktopOrLaptop = useMediaQuery(IS_DESKTOP_OR_LAPTOP);
    const [dataScanned, setDataScanned] = useState('');

    useEffect(() => {
        Keyboard.addListener('keyboardDidShow', () => setKeyboardShow(true))
        Keyboard.addListener('keyboardDidHide', () => setKeyboardShow(false))
    }, [Keyboard])

    useEffect(() => {
        loadMarketInfo()
    }, [])

    useEffect(() => {
        if (!categoryState.loading) {
            loadCategories();
        }

        if (!storeInfo && !loadingMarketInfo) {
            loadMarketInfo();
        }

    }, [loadingMarketInfo]);
 
    useEffect(() => {
        
        if (!loading && !_.isEqual(uiSettings.favoriteCarriers, loadedCarriers)) {
            setLoading(true);
            const fetchCarrier = async () => {
                try {
                    const { data } = await client.query({
                        query: FAVORITE_CARRIERS,
                        fetchPolicy: "no-cache",
                        variables: {
                            ids: uiSettings.favoriteCarriers,
                        }
                    });
                    const carriers: Carrier[] = [];
                    _.forEach(data.nodes, (node) => {
                        carriers.push({
                            id: node.id,
                            sku: node.sku,
                            name: node.name,
                            color: node.bgColor || '#26A69A',
                            standalonePaymentLink: node.standalonePaymentLink,
                            country: node.country,
                            logoUrl: node.logoUrl || 'data:image/jpeg;base64,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'
                        });
                    });
                    setCarriers(carriers);
                    setLoadedCarriers(uiSettings.favoriteCarriers);
                    setLoading(false);
                } catch (err) {
                    setLoading(false);
                }
            }
            fetchCarrier();
        }
    }, [loadedCarriers, setLoadedCarriers, uiSettings]);

    const changeTab = React.useCallback((value) => {
        return setTab(value);
    }, []);

    if (!storeInfo) {
        return <LoadingComponent />
    }
    return (
        <View style={{ height: '100%' }}>
            <ScrollView showsVerticalScrollIndicator={false}>
                <View style={{
                    paddingHorizontal: !isDesktopOrLaptop ? 20 : undefined,
                    paddingTop: 20,
                    paddingBottom: !isDesktopOrLaptop ? '22%' : '12%',
                }}>
                    {!isSmartPhone ?
                        <View style={{ flexDirection: 'row', justifyContent: 'center' }}>

                            <View style={{ width: '45%', flexDirection: 'column' }}>
                                <HomeIntroWeb
                                    carriers={carriers}
                                    storeInfo={storeInfo}
                                    loadingCarriers={loading}
                                />
                            </View>

                            <Divider style={{ width: 1, height: '100%', marginLeft: '1.5%', marginRight: '1.5%' }} />

                            <View style={{ width: '45%', flexDirection: 'column' }}>
                                <HomeContent
                                    onQuickSale={quickSale}
                                    categories={categoryState.categories}
                                    carriers={carriers}
                                    selectCategory={selectCategory}
                                    selectCarrier={selectCarrier}
                                    selectProduct={selectProduct}
                                    uiSettings={uiSettings}
                                    onSaveSettings={saveSettings}
                                />
                            </View>

                        </View>
                        :
                        (<HomeContent
                            onQuickSale={quickSale}
                            categories={categoryState.categories}
                            carriers={carriers}
                            selectCategory={selectCategory}
                            selectCarrier={selectCarrier}
                            selectProduct={selectProduct}
                            uiSettings={uiSettings}
                            onSaveSettings={saveSettings}
                            tab={tab}
                            dataScanned={dataScanned}
                        />)}
                </View>
            </ScrollView>
            {!keyboardShow || isWebPlatform() ?
                <View>
                    {isSmartPhone && !isWebPlatform() ?
                        <BottomTabNavigator
                            selectionTab={changeTab}
                            currentTabOption={tab}
                            scanning={(data) => setDataScanned(data)} /> :
                        <Footer />}
                </View> : null}
        </View >
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    tinyLogo: {
        resizeMode: 'stretch',
        width: 100,
        height: 100,
    }
})